<template>
  <v-app id="app">
    <v-navigation-drawer v-model="drawer" :clipped="true" :mini-variant="$vuetify.breakpoint.mdAndDown" :permanent="drawer" app>
      <v-list dense>
        <template v-for="item in items">
          <v-row v-if="!itemAuthorized(item)" :key="item.heading + item.text"></v-row>
          <v-row v-else-if="item.heading" :key="item.heading" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-col>
            <v-col cols="6" class="text-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :append-icon="item.model ? item.post_icon : item['post_icon-alt']"
          >
            <template v-slot:activator>
              <v-list-item-action>
                <v-icon :title="item.text">{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item v-for="(child, i) in item.children" :key="i" :to="child.link" link>
              <v-list-item-action v-if="child.icon">
                <v-icon :title="child.text">{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ child.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :key="item.text" :to="item.link" link>
            <v-list-item-action>
              <v-icon :title="item.text">{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar :clipped-left="true" app dark color="primary">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <img src="./assets/gsmd-seal.png" height="35" class="mb-n2" />
        <span class="hidden-sm-and-down pl-2">GSMD Virtual Vault</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>mdi-bell</v-icon>
      </v-btn>
      <v-btn icon>
        <v-avatar v-if="user.user && user.user.picture" size="28"><img :src="user.user.picture"/></v-avatar>
      </v-btn>
    </v-app-bar>

    <v-main>
      <div id="container-wrapper">
        <Notifications />
        <v-container class="container-viewer">
          <v-row>
            <router-view id="view" :key="$route.fullPath"></router-view>
          </v-row>
        </v-container>
      </div>
    </v-main>

    <!--FAB commented out for now
    <v-btn bottom color="pink" dark fab fixed right @click="dialog = !dialog">
      <v-icon>mdi-plus</v-icon>
    </v-btn>-->
  </v-app>
</template>

<script>
import Notifications from "@/components/Notifications.vue";
import NProgress from "nprogress";
import store from "@/store";
import { mapState } from "vuex";

export default {
  components: {
    Notifications
  },
  mounted() {
    NProgress.configure({ parent: "#container-wrapper" });
  },
  props: {
    source: String
  },
  data: () => ({
    dialog: false,
    drawer: true,
    items: [
      { icon: "mdi-home", text: "Home", link: "/" },
      { icon: "mdi-format-list-checks", text: "Browse Lineages", link: "/browse", authRequired: true },
      { icon: "mdi-file-find", text: "Search Individuals", link: "/search", authRequired: true }
    ]
  }),
  computed: mapState(["user"]),
  methods: {
    itemAuthorized(item) {
      return !item.authRequired || (store.getters.userIsLoggedIn && store.getters.userHasSignedNda);
    }
  }
};
</script>

<style>
#nprogress div.bar {
  height: 4px;
}
thead {
  vertical-align: top;
}
/* .columns-resize-bar {
  border-left: solid 1px #ccc;
  height: 100px;
  max-height: 31px;
} */
.container-viewer {
  max-width: 99% !important;
}
</style>
